import { buildRange } from '../numericHelper';

import { CONDITION } from './profileConstants';
import { UK_CAR_MAKES_WITH_MODELS } from './ukCarMakesModels';

export const UK_LICENSE_TYPES = [
  'Full Car',
  'Advanced Car',
  'Driving Instructor',
  'LGV (HGV) Class 1',
  'LGV (HGV) Class 2',
  'Motorcycle Under 125cc',
  'Motorcycle Above 125cc',
  'PCV (PSV) Coach',
  'PCV (PSV) Minibus',
  'Taxi',
];

export const US_LICENSE_TYPES = [
  "Learner's Permit",
  'Class D',
  'Class M',
  'CDL Class A',
  'CDL Class B',
  'CDL Class C',
  'Taxi/Livery License',
  'Chauffeur’s License',
  'School Bus License',
  'Moped or Scooter License',
  'RV License',
  'Farm Equipment License',
];

export const US_LICENSE_COMPLETE_LABELS = {
  "Learner's Permit": 'Learner’s Permit',
  'Class D': 'Class D (Passenger Car - Regular Driver’s License)',
  'Class M': 'Class M (Motorcycle License)',
  'CDL Class A': 'CDL Class A (Semi-Trucks, Large Trailers)',
  'CDL Class B': 'CDL Class B (Buses, Box Trucks, Dump Trucks)',
  'CDL Class C': 'CDL Class C (HazMat, Passenger Vehicles)',
  'Taxi/Livery License':
    'Taxi/Livery License (For Professional Driving Services)',
  'Chauffeur’s License': 'Chauffeur’s License',
  'School Bus License': 'School Bus License',
  'Moped or Scooter License': 'Moped or Scooter License',
  'RV License': 'RV License (For Large Motorhomes)',
  'Farm Equipment License': 'Farm Equipment License',
};

export const UK_LICENSE_OPTIONS = UK_LICENSE_TYPES.map((license) => ({
  label: license,
  value: license,
}));

export const US_LICENSE_OPTIONS = US_LICENSE_TYPES.map((license) => ({
  label: US_LICENSE_COMPLETE_LABELS[license],
  value: license,
}));

export const CAR_YEARS = buildRange(new Date().getFullYear(), 1970).reverse();

export const CAR_YEAR_OPTIONS = CAR_YEARS.map((year) => ({
  label: year,
  value: year,
}));

export const CAR_TYPES = [
  'Convertible',
  'SUV',
  'Sedan',
  'Crossover',
  'Station Wagon',
  'Van',
  'Sports',
  'Truck',
  'Motorcycle',
  'Other',
];

export const CAR_TYPE_OPTIONS = CAR_TYPES.map((carType) => ({
  label: carType,
  value: carType,
}));

export const CAR_CONDITION_OPTIONS = CONDITION.map((carCondition) => ({
  label: carCondition,
  value: carCondition,
}));

export const CAR_COLORS = [
  'White',
  'Black',
  'Grey',
  'Silver',
  'Gold',
  'Tan',
  'Brown',
  'Burgundy',
  'Red',
  'Orange',
  'Yellow',
  'Green',
  'Blue',
  'Purple',
];

export const CAR_COLOR_OPTIONS = CAR_COLORS.map((carColor) => ({
  label: carColor,
  value: carColor,
}));

export const UK_CAR_MAKE_OPTIONS = UK_CAR_MAKES_WITH_MODELS.map(
  ({ carMake }) => ({
    label: carMake,
    value: carMake,
  })
);
